import { getFetchAccountsRequest, getUpdateAccountsRequest } from 'selectors'
import { error, success } from '@segment/notify'
import fetch from 'lib/fetch'

export const FETCH_ACCOUNTS = 'FETCH_ACCOUNTS'
export const FETCHED_ACCOUNTS = 'FETCHED_ACCOUNTS'
export const FETCH_ACCOUNTS_ERROR = 'FETCH_ACCOUNTS_ERROR'

export function fetchAccounts (workspaceSlug, sourceSlug) {
  return {
    types: {
      request: FETCH_ACCOUNTS,
      receive: FETCHED_ACCOUNTS,
      failure: FETCH_ACCOUNTS_ERROR
    },
    payload: { workspaceSlug, sourceSlug },
    shouldCallAPI: function (state) {
      const req = getFetchAccountsRequest(state, workspaceSlug, sourceSlug)
      return !req || !req.isRequesting
    },
    callAPI: function () {
      return fetch(`/api/workspaces/${workspaceSlug}/projects/${sourceSlug}/accounts`)
        .then((res) => {
          if (!res.ok) {
            throw new Error('Unable to fetch accounts')
          }
          return res.json()
        })
    }
  }
}

export const UPDATE_ACCOUNTS = 'UPDATE_ACCOUNTS'
export const UPDATED_ACCOUNTS = 'UPDATED_ACCOUNTS'
export const UPDATE_ACCOUNTS_ERROR = 'UPDATE_ACCOUNTS_ERROR'

export function updateAccounts (workspaceSlug, sourceSlug, accountIds) {
  return {
    types: {
      request: UPDATE_ACCOUNTS,
      receive: UPDATED_ACCOUNTS,
      failure: UPDATE_ACCOUNTS_ERROR
    },
    payload: { workspaceSlug, sourceSlug },
    shouldCallAPI: function (state) {
      const req = getUpdateAccountsRequest(state, workspaceSlug, sourceSlug)
      return !req || !req.isRequesting
    },
    callAPI: function () {
      return fetch(`/api/workspaces/${workspaceSlug}/projects/${sourceSlug}/accounts`, {
        method: 'PATCH',
        body: JSON.stringify({ accountIds: accountIds })
      }).then((res) => {
        if (!res.ok) {
          throw new Error('Unable to fetch accounts')
        }
        return res.json()
      })
      .then(res => {
        success('You successfully saved accounts')
        return res
      })
      .catch((err) => {
        error('Unable to set accounts')
        throw err
      })
    }
  }
}



// WEBPACK FOOTER //
// ./actions/accounts.js